import React from 'react'

const Other = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <circle fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={107.607} cy={256} r={44.169} />
    <circle fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={256} cy={256} r={44.169} />
    <circle fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={404.393} cy={256} r={44.169} />
  </svg>
)
export default Other
